module.exports = __webpack_public_path__ + "static/media/shutterstock_1860509911.ad7e6bb3.png";